export class MatTableHelpers{
  static  getPropertyByPath(obj: Object, pathString: string) {
        let r = pathString.split('.').reduce((o, i) => o!=null?o[i]:null, obj);
        if (typeof r === 'string')
          r = r.toLowerCase();
        return r;
      }
}